export default __webpack_public_path__ + "static/media/53.16061b07.jpg";